import React from 'react';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import DigitalOnboardingRealAssetInfoTemplate
  from 'Views/Page/Content/Templates/DigitalOnboardingRealAssetInfo/DigitalOnboardingRealAssetInfoTemplate';
import BalanceSheetRealAssetTypeTemplate
  from 'Views/Page/Content/Modal/Layouts/BalanceSheetRealAssetTypeStep/Layout/BalanceSheetRealAssetTypeStepTemplate';

export const BalanceSheetRealAssetTypeDOLayout = () => {
  const { refreshOnboardingStepCollection } = useSurveyContext();

  return (
    <BalanceSheetRealAssetTypeTemplate onRefresh={refreshOnboardingStepCollection} infoLayoutComponent={DigitalOnboardingRealAssetInfoTemplate} useFD />
  );
};
